export const drawerStyles = {
  // sx is a prop that allows you to style the component using the MUI theme object
  width: 200,
  flexShrink: 0,
  "& .MuiDrawer-paper": {
    width: 200,
    boxSizing: "border-box",
  },
};

export const navbarButtonsStyles = {
  color: "inherit",
  textDecoration: "none",
};
